import api, { handleResponse, handleError } from './api';

const curatorService = {
  /**
   * Curation queue — all live events filtered by region/category/status.
   * Returns events sorted by heat score descending.
   */
  /**
   * The curation pool. Area is a point + radius (from the same city search the
   * rest of the app uses) rather than a regionId — see AREA_NOTE in
   * the PICK EVENTS page. `origin` is 'authored' | 'scraped' | null.
   */
  async getQueue({
    regionId = null, category = null, status = null, q = null,
    lat = null, lng = null, radiusMiles = null, origin = null, sort = null,
  } = {}) {
    try {
      const params = new URLSearchParams();
      if (regionId) params.set('regionId', regionId);
      if (category) params.set('category', category);
      if (status) params.set('status', status);
      if (q && q.trim()) params.set('q', q.trim());
      // 0 is not a meaningful coordinate here, but it IS a valid one — check for
      // null explicitly so a point on the equator or prime meridian survives.
      if (lat != null && lng != null) {
        params.set('lat', lat);
        params.set('lng', lng);
        if (radiusMiles) params.set('radiusMiles', radiusMiles);
      }
      if (origin) params.set('origin', origin);
      if (sort) params.set('sort', sort);
      const response = await api.get(`/curator/events${params.toString() ? `?${params}` : ''}`);
      return handleResponse(response);
    } catch (error) {
      return handleError(error);
    }
  },

  async featureEvent(eventId, { regionId = null, category, position = 0 }) {
    try {
      const response = await api.post(`/curator/events/${eventId}/feature`, {
        regionId,
        category,
        position,
      });
      return handleResponse(response);
    } catch (error) {
      return handleError(error);
    }
  },

  async unfeatureEvent(eventId) {
    try {
      const response = await api.delete(`/curator/events/${eventId}/feature`);
      return handleResponse(response);
    } catch (error) {
      return handleError(error);
    }
  },

  /** Current live wall picks for a region. */
  async getWall(regionId) {
    try {
      const response = await api.get(`/curator/wall/${regionId}`);
      return handleResponse(response);
    } catch (error) {
      return handleError(error);
    }
  },
};

export default curatorService;
